/* eslint-disable import/extensions */
import axios from 'axios';
import KNB from '@dp/knb';
import { getPath } from './path.js';
import getEnv from './env.js';

axios.defaults.withCredentials = true;

const pathObj = getPath();

let ua = navigator.userAgent.toLocaleLowerCase();

let isAndroid = ua.indexOf('android') > 0;

let isIos = /iphone|ipad|ipod|ios/.test(ua);

let isApp = /merchant/.test(ua);

let isTest = getEnv() !== 'prd';

/**
 * [getAjaxUrl description]
 * @param  {[type]} url       [description]
 * @return {[type]}           [description]
 */
function getAjaxUrl(options) {
    if (/^https?:\/\//g.test(options.url)) {
        return options.url;
    }
    return `${pathObj.ajax}/${options.url}`;
}

function successHandle(response, options) {
    if (response && response.data) {
        if (options.success) {
            options.success(response.data);
        }
    } else if (options.error) {
        options.error(response);
    }
}

function errorHandle(error, options) {
    if (error.response) {
        if (error.response.status === 401) {
            console.log('401');
        } else if (error.response.status === 403) {
            console.log('403');
        } else if (options.error) {
            options.error(error);
        }
    } else if (options.error) {
        options.error(error);
    }
}

/**
 * [ajax封装，包括环境域名判断，路径拼接，sso跳转]
 * @param  {[type]} options []
 * options.url
 * options.params
 * options.success
 * options.error
 * @return {[type]}[description]
 */
const Ajax = {
    get(options) {
        const header = {
            'X-Requested-With': 'XMLHttpRequest',
            ...(options.headers || {}),
        };
        axios.get(getAjaxUrl(options), {
            params: options.params,
            headers: header,
        })
            .then((response) => {
                successHandle(response, options);
            }, (error) => {
                errorHandle(error, options);
            })
            .catch((error) => {
                errorHandle(error, options);
            });
    },
    post(options) {
        const header = {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
            ...(options.headers || {}),
        };
        axios.post(getAjaxUrl(options), options.params, { headers: header })
            .then((response) => {
                successHandle(response, options);
            }, (error) => {
                errorHandle(error, options);
            })
            .catch((error) => {
                errorHandle(error, options);
            });
    },
    delete(options) {
        const header = {
            'X-Requested-With': 'XMLHttpRequest',
        };
        axios.delete(getAjaxUrl(options), {
            headers: header,
        })
            .then((response) => {
                successHandle(response, options);
            }, (error) => {
                errorHandle(error, options);
            })
            .catch((error) => {
                errorHandle(error, options);
            });
    },
    put(options) {
        const header = {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        };
        axios.put(getAjaxUrl(options), options.params, { headers: header })
            .then((response) => {
                successHandle(response, options);
            }, (error) => {
                errorHandle(error, options);
            })
            .catch(error => errorHandle(error, options));
    },
};

function getUrlParam(paramName, search = location.search) {
    const paramList = {};
    if (search) {
        search.substr(1, search.length - 1).split('&').forEach((param) => {
            const p = param.split('=');
            paramList[p[0]] = p[1];
        });
    }
    return paramList[paramName] || '';
}

/**
 * base64图片格式处理
 * @param localId
 * @returns {string}
 */
function processImage(localId) {
    const index = localId.indexOf('base64,');
    return localId.substr(index + 7, localId.length - index - 7);
}

function throttle(fn, wait) {
    let time = Date.now();
    return () => {
        if (((time + wait) - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    };
}

function hideNavigationBar() {
    KNB.setNavigationBarHidden({
        flag: 1, // 0表示显示，1表示隐藏
    });
}
function forbidDebounce() {
    KNB.setBouncesEnabled({
        enabled: 0, // 1表示允许反弹，0表示禁止。default: 1
    });
}
function getUserInfo(){
    return KNB.uaInfo();
}

function getParams(name) {
    const searchArr = location.search.slice(1).split('&');
    const searchItem = searchArr.filter(item => item.indexOf(name) >= 0)[0];
    return searchItem && searchItem.split('=')[1];
}

function cookie(key, value, options) {
    let cookie, cookies, len, name, result = false;

    if (arguments.length > 1) {
        options = options || {};
        if (typeof options.expires === 'number') {
            var hours = options.expires,
                t     = options.expires = new Date();
            t.setMilliseconds(t.getMilliseconds()+1000*60*60*hours);
        }
            return (document.cookie = [
                    key,'=',value,
                    options.expires ? '; expires=' + options.expires.toUTCString() : '',
                    options.path ? '; path=' + options.path : '',
                    options.domain ? '; domain=' + options.domain : '',
                    options.secure ? '; secure' : ''
                   ].join(''));

    } else {
        if (!key) return false;
        cookies = document.cookie ? document.cookie.split('; ') : [];
        len = cookies.length;

        for (var i = 0; i < len; i++) {
            cookie = cookies[i].split('=');
            name = cookie.shift();

            if (name === key) {
                result = cookie.join('');
                break;
            }
        }
        return result;
    }
}

function callApp(appUrl, h5Url, timeout = 2000) {
    if (isAndroid) {
        const div = document.createElement('div');
        div.style.visibility = 'hidden';
        div.innerHTML = `<iframe id="schema" src="${appUrl}" scrolling="no" width="1" height="1"></iframe>`;
        document.body.appendChild(div);
    } else if (isIos) {
        setTimeout(() => {
            window.location = appUrl;
            // let b = document.createElement('a');
            // b.setAttribute('href', appUrl),
            // b.style.display = 'none',
            // document.body.appendChild(b);
            // let c = document.createEvent('HTMLEvents');
            // c.initEvent('click', !1, !1),
            // b.dispatchEvent(c);
        }, 10);
    }

    if (h5Url) {
        setTimeout(() => {
            window.location = h5Url
        }, timeout);
    }
}

function formatDate(date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    let ret = `${year}-${month}-${day}`;
    return ret;
}

export { Ajax, getUrlParam, throttle, hideNavigationBar, forbidDebounce, getParams, getUserInfo, cookie, callApp, isApp, isTest, formatDate };



// WEBPACK FOOTER //
// ./lib/utils.js